import { AtomButtonProps } from 'wolf/components/atoms/a-button/a-button.data';
import { AtomCopyProps } from 'wolf/components/atoms/a-copy/a-copy.data';
import { AtomHeadlineProps } from 'wolf/components/atoms/a-headline/a-headline.data';
import { Component } from '../../../../global/interfaces/component.interface';


export interface MoleculeVideoOverlayProps {
	layout?: 0 | 1 | 2 | 3 | 4;
    /** The headline */
	headline?: AtomHeadlineProps;
	/** The subheadline */
	subheadline?: AtomHeadlineProps;
	/** The copy text */
	copy?: AtomCopyProps;
	/** The button */
	button?: AtomButtonProps;
}

// Just a big play button
export const MyMoleculeVideoOverlayLayoutDefault: Component<MoleculeVideoOverlayProps> = {
    data: {
		// no props
    }
}

// As seen on the knowledge base (I think)
export const MyMoleculeVideoOverlayLayout1: Component<MoleculeVideoOverlayProps> = {
    data: {
		layout: 1,
        headline: {
			text: 'Der Luftreiniger Der Profis',
			style: 1,
		},
		copy: {
			text: '<p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Asperiores minima quidem unde vitae reiciendis rerum itaque a aperiam! A, eius. Ab facilis tempora optio dolore mollitia nesciunt eligendi voluptate quos?</p>',
		},
    }
}

// As seen on the job portal
export const MyMoleculeVideoOverlayLayout2: Component<MoleculeVideoOverlayProps> = {
    data: {
		layout: 2,
        headline: {
			text: 'Folge 1',
			style: 5,
		},
		subheadline: {
			text: 'WOLF Junior Reporter<br/>Unterwegs im Werk in Mainburg',
			style: 4,
		},
		copy: {
			text: '<p>Mit Gina, Dominik und Jürgen-Anton</p>',
		},
    }
}

// As seen on the private pages?
export const MyMoleculeVideoOverlayLayout3: Component<MoleculeVideoOverlayProps> = {
    data: {
		layout: 3,
        headline: {
			text: 'Wärmepumpen<br/>Verstehen',
			style: 1,
		},
		copy: {
			text: '<p>Dieses Video wird sie von den Socken hauen -100%-ige Trennung der Zu– und Ablaufströme. Hocheffiziente Wärmerückgewinnung in Bereichen mit besonders hohen Anforderungen an die Raumluftqualität.</p>',
		},
		button: {
			href: 'https://www.google.com',
			text: 'Call to Action',
			target: '_blank',
			title: 'Call to action',
			type: 'primary-blue',
		}
    }
}

// As seen on the FHW search
export const MyMoleculeVideoOverlayLayout4: Component<MoleculeVideoOverlayProps> = {
    data: {
		layout: 4,
        headline: {
			text: 'Fachpartner Headline',
			style: 1,
		},
		subheadline: {
			text: 'Hier eine flotte Subjeadline',
			style: 1,
		},
		copy: {
			text: '<p>Unternehmen Gmbh, Musterstadt</p>',
		},
    }
}

// As seen on the professional pages
export const MyMoleculeVideoOverlayLayout5: Component<MoleculeVideoOverlayProps> = {
    data: {
		// no props, no design so just a play button?
    }
}
